import { gsap } from 'gsap'

const accordions = document.querySelectorAll('[data-notice-bar-toggle]')

Array.from(accordions).forEach((accordion) => {
    accordion.addEventListener('click', function () {
        const elParent = this.closest('[data-notice-bar]')
        const elMain = elParent.querySelector('[data-notice-bar-main]')
        const elButton = accordion.querySelector('button')
        const elEllipsis = elParent.querySelector('[data-notice-bar-ellipsis]')
        console.log(elEllipsis)

        if (elParent.getAttribute('data-open') === 'true') {
            elParent.setAttribute('data-open', 'false')
            elButton.setAttribute('aria-expanded', 'false')
            elMain.setAttribute('aria-hidden', 'true')
            elEllipsis.setAttribute('aria-hidden', 'true')
            return
        }

        elParent.setAttribute('data-open', 'true')
        elButton.setAttribute('aria-expanded', 'true')
        elMain.setAttribute('aria-hidden', 'false')
        elEllipsis.setAttribute('aria-hidden', 'false')
    })

})

